<template>
  <transition name="toast">
    <div v-if="toast" class="notification-toast">
      <span v-if="toast.title" class="toast-title">{{ toast.title }}</span>
      <span v-if="toast.body" class="toast-body">{{ toast.body }}</span>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NotificationToast',
  computed: {
    ...mapState(['toast'])
  }
}
</script>

<style scoped>
.notification-toast {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #4f46e5;
  color: #ffffff;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  max-width: 320px;
  text-align: center;
  white-space: nowrap;
}

.toast-title {
  font-weight: 700;
}

.toast-body {
  font-weight: 400;
  font-size: 0.8rem;
  opacity: 0.9;
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.toast-enter,
.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}

@media (max-width: 768px) {
  .notification-toast {
    bottom: 104px; /* Above bottom nav */
  }
}
</style>
